<template>
  <div id="index">
    <Header></Header>
    <Search></Search>
    <div class="content">
      <div class="w index-content">
        <Banner :banner_list="banner_list"
                :cat_list="cat_list" ></Banner>
        <Floor :floor_list="floor_list" 
                :goods_list="goods_list"
                :top_list="top_list"
                :hot_review_list="hot_review_list"
                :brand_list="brand_list"
                :centerImg="centerImg"
               ></Floor>
        <forYou :for_you_list="for_you_list" v-if="for_you_list.length != 0"></forYou>
               <!-- :for_you_list="for_you_list" -->
        <div class="back-top"
             :class="{'active' : scroll_top}"
             @click="backTop">Top</div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/purchase/header/header'
import Search from '@/components/purchase/search/search'
import Floor from './components/floor'
import Footer from '@/components/purchase/footer/footer'
import Banner from './components/banner'
import forYou from './components/forYou'

export default {
  components: {
    Search,
    Header,
    Banner,
    Floor,
    Footer,
    forYou
  },
  data() {
    return {
      route_url: this.$route.params.route_url,
      scroll_top: false,
      // template_list: [],
      banner_list: [], //banner图
      cat_list: [], //分类列表
      floor_list: [], //楼层列表
      // img_list:"",//图片
      goods_list:[],//好物列表
      top_list:[],//排行榜
      hot_review_list:[],//热评商品
      brand_list:[],//品牌推荐
      for_you_list:[],//为你推荐
      centerImg:""
    }
  },
  created() {
    this.getData()
  },
  mounted() {
    let that = this
    window.onscroll = function() {
      let scroll_top =
        document.documentElement.scrollTop || document.body.scrollTop
      if (scroll_top >= 400) {
        that.scroll_top = true
      } else {
        that.scroll_top = false
      }
    }
  },
  methods: {
    getData() {
      this.$api
        .qycgIndex({
          shop_type: 'qycg'
        })
        .then(res => {
          if (res.code == 0) {
            this.centerImg=res.data.center_img
            this.banner_list = res.data.banner
            this.cat_list = res.data.cat
            this.goods_list=res.data.recommend_list 
            this.floor_list = res.data.floor_list
            this.top_list=res.data.chart_list
            this.hot_review_list=res.data.hot_review_list
            this.brand_list=res.data.brand_list
            this.for_you_list=res.data.for_you_list
          }
        })
        .catch(err => {
          this.common.message(this, err)
        })
    },
    backTop() {
      this.common.backTop(20)
    }
  }
}
</script>

<style lang="scss" scoped>
.w {
  position: relative;
}

.content {
  width: 100%;
  height: 100%;
  background-color: #f2f2f2;
  border: 1px solid #f2f2f2;
  padding-bottom: 60px;
  box-sizing: border-box;

  .index-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}

.back-top {
  cursor: pointer;
  font-size: 14px;
  position: fixed;
  text-align: center;
  z-index: 9999;
  visibility: hidden;
  opacity: 0;
  transition: 1s;
  background: #121212;
  color: #ffffff;
  border-radius: 3px;
  padding: 12px;
  right: 20px;
  bottom: 45px;
}
.back-top.active {
  visibility: visible;
  opacity: 1;
  filter: alpha(opacity=100);
  transition: 0.3s;
}
</style>
